export const toGet = ({ type, project, withRoles, withRolesDescription, withPermissionsSlugIndex, withPermissionsSlugNewIndex }) => ({
  type,
  object_id: project.id,
  append: [
    withRoles && 'roles',
    withRolesDescription && 'roles_description',
    withPermissionsSlugIndex && 'permissions_slug_index',
    withPermissionsSlugNewIndex && 'permissions_slug_new_index'
  ].filter(is)
})
